/* eslint-disable */
// @generated by protobuf-ts 2.8.2 with parameter add_pb_suffix,use_proto_field_name,ts_nocheck,eslint_disable
// @generated from protobuf file "brandguard.product.detection.proto" (package "brandguard.product", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.DetectedProduct
 */
export interface DetectedProduct {
    /**
     * @generated from protobuf field: string product_id = 1 [json_name = "product_id"];
     */
    product_id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated string aliases_matched = 3 [json_name = "aliases_matched"];
     */
    aliases_matched: string[];
    /**
     * @generated from protobuf field: double confidence = 4;
     */
    confidence: number;
    /**
     * @generated from protobuf field: string location = 5;
     */
    location: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductDetectionResult
 */
export interface ProductDetectionResult {
    /**
     * @generated from protobuf field: repeated brandguard.product.DetectedProduct products = 1;
     */
    products: DetectedProduct[];
    /**
     * @generated from protobuf field: string raw_text = 2 [json_name = "raw_text"];
     */
    raw_text: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductTaxonomy
 */
export interface ProductTaxonomy {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string account_id = 2 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string content_type = 4 [json_name = "content_type"];
     */
    content_type: string;
    /**
     * @generated from protobuf field: string name = 5;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated string aliases = 6;
     */
    aliases: string[];
    /**
     * @generated from protobuf field: string category = 7;
     */
    category: string;
    /**
     * @generated from protobuf field: string team_owner = 8 [json_name = "team_owner"];
     */
    team_owner: string;
    /**
     * @generated from protobuf field: string created_at = 9 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: string updated_at = 10 [json_name = "updated_at"];
     */
    updated_at: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductTaxonomySearchRequest
 */
export interface ProductTaxonomySearchRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: string brand_id = 2 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string content_type = 3 [json_name = "content_type"];
     */
    content_type: string;
    /**
     * @generated from protobuf field: uint64 limit = 4;
     */
    limit: bigint;
    /**
     * @generated from protobuf field: string category = 5;
     */
    category: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductTaxonomySearchResponse
 */
export interface ProductTaxonomySearchResponse {
    /**
     * @generated from protobuf field: repeated brandguard.product.ProductTaxonomy items = 1;
     */
    items: ProductTaxonomy[];
    /**
     * @generated from protobuf field: brandguard.product.ProductTaxonomySearchRequest next = 2;
     */
    next?: ProductTaxonomySearchRequest;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductTaxonomyCreateRequest
 */
export interface ProductTaxonomyCreateRequest {
    /**
     * @generated from protobuf field: string brand_id = 1 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string content_type = 2 [json_name = "content_type"];
     */
    content_type: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated string aliases = 4;
     */
    aliases: string[];
    /**
     * @generated from protobuf field: string category = 5;
     */
    category: string;
    /**
     * @generated from protobuf field: string team_owner = 6 [json_name = "team_owner"];
     */
    team_owner: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductTaxonomyUpdateRequest
 */
export interface ProductTaxonomyUpdateRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated string aliases = 3;
     */
    aliases: string[];
    /**
     * @generated from protobuf field: string category = 4;
     */
    category: string;
    /**
     * @generated from protobuf field: string team_owner = 5 [json_name = "team_owner"];
     */
    team_owner: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductDetectionExplanation
 */
export interface ProductDetectionExplanation {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string account_id = 2 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string event_id = 4 [json_name = "event_id"];
     */
    event_id: string;
    /**
     * @generated from protobuf field: string created_at = 5 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: string explanation = 6;
     */
    explanation: string;
    /**
     * @generated from protobuf field: repeated brandguard.product.DetectedProduct detected_products = 7 [json_name = "detected_products"];
     */
    detected_products: DetectedProduct[];
    /**
     * @generated from protobuf field: int32 page_number = 8 [json_name = "page_number"];
     */
    page_number: number;
    /**
     * @generated from protobuf field: int64 timestamp_ms = 9 [json_name = "timestamp_ms"];
     */
    timestamp_ms: bigint;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductDetectionExplanationSearchRequest
 */
export interface ProductDetectionExplanationSearchRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: repeated string event_ids = 2 [json_name = "event_ids"];
     */
    event_ids: string[];
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: uint64 limit = 4;
     */
    limit: bigint;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.product.ProductDetectionExplanationSearchResponse
 */
export interface ProductDetectionExplanationSearchResponse {
    /**
     * @generated from protobuf field: repeated brandguard.product.ProductDetectionExplanation items = 1;
     */
    items: ProductDetectionExplanation[];
    /**
     * @generated from protobuf field: brandguard.product.ProductDetectionExplanationSearchRequest next = 2;
     */
    next?: ProductDetectionExplanationSearchRequest;
}
// @generated message type with reflection information, may provide speed optimized methods
class DetectedProduct$Type extends MessageType<DetectedProduct> {
    constructor() {
        super("brandguard.product.DetectedProduct", [
            { no: 1, name: "product_id", kind: "scalar", localName: "product_id", jsonName: "product_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "aliases_matched", kind: "scalar", localName: "aliases_matched", jsonName: "aliases_matched", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DetectedProduct>): DetectedProduct {
        const message = { product_id: "", name: "", aliases_matched: [], confidence: 0, location: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetectedProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetectedProduct): DetectedProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string product_id = 1 [json_name = "product_id"];*/ 1:
                    message.product_id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated string aliases_matched = 3 [json_name = "aliases_matched"];*/ 3:
                    message.aliases_matched.push(reader.string());
                    break;
                case /* double confidence */ 4:
                    message.confidence = reader.double();
                    break;
                case /* string location */ 5:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetectedProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string product_id = 1 [json_name = "product_id"]; */
        if (message.product_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.product_id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated string aliases_matched = 3 [json_name = "aliases_matched"]; */
        for (let i = 0; i < message.aliases_matched.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.aliases_matched[i]);
        /* double confidence = 4; */
        if (message.confidence !== 0)
            writer.tag(4, WireType.Bit64).double(message.confidence);
        /* string location = 5; */
        if (message.location !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.DetectedProduct
 */
export const DetectedProduct = new DetectedProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductDetectionResult$Type extends MessageType<ProductDetectionResult> {
    constructor() {
        super("brandguard.product.ProductDetectionResult", [
            { no: 1, name: "products", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DetectedProduct },
            { no: 2, name: "raw_text", kind: "scalar", localName: "raw_text", jsonName: "raw_text", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductDetectionResult>): ProductDetectionResult {
        const message = { products: [], raw_text: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductDetectionResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductDetectionResult): ProductDetectionResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.product.DetectedProduct products */ 1:
                    message.products.push(DetectedProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string raw_text = 2 [json_name = "raw_text"];*/ 2:
                    message.raw_text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductDetectionResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.product.DetectedProduct products = 1; */
        for (let i = 0; i < message.products.length; i++)
            DetectedProduct.internalBinaryWrite(message.products[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string raw_text = 2 [json_name = "raw_text"]; */
        if (message.raw_text !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.raw_text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductDetectionResult
 */
export const ProductDetectionResult = new ProductDetectionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductTaxonomy$Type extends MessageType<ProductTaxonomy> {
    constructor() {
        super("brandguard.product.ProductTaxonomy", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "content_type", kind: "scalar", localName: "content_type", jsonName: "content_type", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "aliases", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "team_owner", kind: "scalar", localName: "team_owner", jsonName: "team_owner", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductTaxonomy>): ProductTaxonomy {
        const message = { id: "", account_id: "", brand_id: "", content_type: "", name: "", aliases: [], category: "", team_owner: "", created_at: "", updated_at: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductTaxonomy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductTaxonomy): ProductTaxonomy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string account_id = 2 [json_name = "account_id"];*/ 2:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* string content_type = 4 [json_name = "content_type"];*/ 4:
                    message.content_type = reader.string();
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* repeated string aliases */ 6:
                    message.aliases.push(reader.string());
                    break;
                case /* string category */ 7:
                    message.category = reader.string();
                    break;
                case /* string team_owner = 8 [json_name = "team_owner"];*/ 8:
                    message.team_owner = reader.string();
                    break;
                case /* string created_at = 9 [json_name = "created_at"];*/ 9:
                    message.created_at = reader.string();
                    break;
                case /* string updated_at = 10 [json_name = "updated_at"];*/ 10:
                    message.updated_at = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductTaxonomy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string account_id = 2 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* string content_type = 4 [json_name = "content_type"]; */
        if (message.content_type !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.content_type);
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* repeated string aliases = 6; */
        for (let i = 0; i < message.aliases.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.aliases[i]);
        /* string category = 7; */
        if (message.category !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.category);
        /* string team_owner = 8 [json_name = "team_owner"]; */
        if (message.team_owner !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.team_owner);
        /* string created_at = 9 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.created_at);
        /* string updated_at = 10 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.updated_at);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductTaxonomy
 */
export const ProductTaxonomy = new ProductTaxonomy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductTaxonomySearchRequest$Type extends MessageType<ProductTaxonomySearchRequest> {
    constructor() {
        super("brandguard.product.ProductTaxonomySearchRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "content_type", kind: "scalar", localName: "content_type", jsonName: "content_type", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductTaxonomySearchRequest>): ProductTaxonomySearchRequest {
        const message = { offset: 0n, brand_id: "", content_type: "", limit: 0n, category: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductTaxonomySearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductTaxonomySearchRequest): ProductTaxonomySearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* string brand_id = 2 [json_name = "brand_id"];*/ 2:
                    message.brand_id = reader.string();
                    break;
                case /* string content_type = 3 [json_name = "content_type"];*/ 3:
                    message.content_type = reader.string();
                    break;
                case /* uint64 limit */ 4:
                    message.limit = reader.uint64().toBigInt();
                    break;
                case /* string category */ 5:
                    message.category = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductTaxonomySearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* string brand_id = 2 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.brand_id);
        /* string content_type = 3 [json_name = "content_type"]; */
        if (message.content_type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.content_type);
        /* uint64 limit = 4; */
        if (message.limit !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.limit);
        /* string category = 5; */
        if (message.category !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.category);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductTaxonomySearchRequest
 */
export const ProductTaxonomySearchRequest = new ProductTaxonomySearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductTaxonomySearchResponse$Type extends MessageType<ProductTaxonomySearchResponse> {
    constructor() {
        super("brandguard.product.ProductTaxonomySearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ProductTaxonomy },
            { no: 2, name: "next", kind: "message", T: () => ProductTaxonomySearchRequest }
        ]);
    }
    create(value?: PartialMessage<ProductTaxonomySearchResponse>): ProductTaxonomySearchResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductTaxonomySearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductTaxonomySearchResponse): ProductTaxonomySearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.product.ProductTaxonomy items */ 1:
                    message.items.push(ProductTaxonomy.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* brandguard.product.ProductTaxonomySearchRequest next */ 2:
                    message.next = ProductTaxonomySearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.next);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductTaxonomySearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.product.ProductTaxonomy items = 1; */
        for (let i = 0; i < message.items.length; i++)
            ProductTaxonomy.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.product.ProductTaxonomySearchRequest next = 2; */
        if (message.next)
            ProductTaxonomySearchRequest.internalBinaryWrite(message.next, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductTaxonomySearchResponse
 */
export const ProductTaxonomySearchResponse = new ProductTaxonomySearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductTaxonomyCreateRequest$Type extends MessageType<ProductTaxonomyCreateRequest> {
    constructor() {
        super("brandguard.product.ProductTaxonomyCreateRequest", [
            { no: 1, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "content_type", kind: "scalar", localName: "content_type", jsonName: "content_type", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "aliases", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "team_owner", kind: "scalar", localName: "team_owner", jsonName: "team_owner", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductTaxonomyCreateRequest>): ProductTaxonomyCreateRequest {
        const message = { brand_id: "", content_type: "", name: "", aliases: [], category: "", team_owner: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductTaxonomyCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductTaxonomyCreateRequest): ProductTaxonomyCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string brand_id = 1 [json_name = "brand_id"];*/ 1:
                    message.brand_id = reader.string();
                    break;
                case /* string content_type = 2 [json_name = "content_type"];*/ 2:
                    message.content_type = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* repeated string aliases */ 4:
                    message.aliases.push(reader.string());
                    break;
                case /* string category */ 5:
                    message.category = reader.string();
                    break;
                case /* string team_owner = 6 [json_name = "team_owner"];*/ 6:
                    message.team_owner = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductTaxonomyCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string brand_id = 1 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.brand_id);
        /* string content_type = 2 [json_name = "content_type"]; */
        if (message.content_type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content_type);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* repeated string aliases = 4; */
        for (let i = 0; i < message.aliases.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.aliases[i]);
        /* string category = 5; */
        if (message.category !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.category);
        /* string team_owner = 6 [json_name = "team_owner"]; */
        if (message.team_owner !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.team_owner);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductTaxonomyCreateRequest
 */
export const ProductTaxonomyCreateRequest = new ProductTaxonomyCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductTaxonomyUpdateRequest$Type extends MessageType<ProductTaxonomyUpdateRequest> {
    constructor() {
        super("brandguard.product.ProductTaxonomyUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "aliases", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "team_owner", kind: "scalar", localName: "team_owner", jsonName: "team_owner", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductTaxonomyUpdateRequest>): ProductTaxonomyUpdateRequest {
        const message = { id: "", name: "", aliases: [], category: "", team_owner: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductTaxonomyUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductTaxonomyUpdateRequest): ProductTaxonomyUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated string aliases */ 3:
                    message.aliases.push(reader.string());
                    break;
                case /* string category */ 4:
                    message.category = reader.string();
                    break;
                case /* string team_owner = 5 [json_name = "team_owner"];*/ 5:
                    message.team_owner = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductTaxonomyUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated string aliases = 3; */
        for (let i = 0; i < message.aliases.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.aliases[i]);
        /* string category = 4; */
        if (message.category !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.category);
        /* string team_owner = 5 [json_name = "team_owner"]; */
        if (message.team_owner !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.team_owner);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductTaxonomyUpdateRequest
 */
export const ProductTaxonomyUpdateRequest = new ProductTaxonomyUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductDetectionExplanation$Type extends MessageType<ProductDetectionExplanation> {
    constructor() {
        super("brandguard.product.ProductDetectionExplanation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "event_id", kind: "scalar", localName: "event_id", jsonName: "event_id", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "detected_products", kind: "message", localName: "detected_products", jsonName: "detected_products", repeat: 1 /*RepeatType.PACKED*/, T: () => DetectedProduct },
            { no: 8, name: "page_number", kind: "scalar", localName: "page_number", jsonName: "page_number", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "timestamp_ms", kind: "scalar", localName: "timestamp_ms", jsonName: "timestamp_ms", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<ProductDetectionExplanation>): ProductDetectionExplanation {
        const message = { id: "", account_id: "", brand_id: "", event_id: "", created_at: "", explanation: "", detected_products: [], page_number: 0, timestamp_ms: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductDetectionExplanation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductDetectionExplanation): ProductDetectionExplanation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string account_id = 2 [json_name = "account_id"];*/ 2:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* string event_id = 4 [json_name = "event_id"];*/ 4:
                    message.event_id = reader.string();
                    break;
                case /* string created_at = 5 [json_name = "created_at"];*/ 5:
                    message.created_at = reader.string();
                    break;
                case /* string explanation */ 6:
                    message.explanation = reader.string();
                    break;
                case /* repeated brandguard.product.DetectedProduct detected_products = 7 [json_name = "detected_products"];*/ 7:
                    message.detected_products.push(DetectedProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 page_number = 8 [json_name = "page_number"];*/ 8:
                    message.page_number = reader.int32();
                    break;
                case /* int64 timestamp_ms = 9 [json_name = "timestamp_ms"];*/ 9:
                    message.timestamp_ms = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductDetectionExplanation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string account_id = 2 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* string event_id = 4 [json_name = "event_id"]; */
        if (message.event_id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.event_id);
        /* string created_at = 5 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.created_at);
        /* string explanation = 6; */
        if (message.explanation !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.explanation);
        /* repeated brandguard.product.DetectedProduct detected_products = 7 [json_name = "detected_products"]; */
        for (let i = 0; i < message.detected_products.length; i++)
            DetectedProduct.internalBinaryWrite(message.detected_products[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 page_number = 8 [json_name = "page_number"]; */
        if (message.page_number !== 0)
            writer.tag(8, WireType.Varint).int32(message.page_number);
        /* int64 timestamp_ms = 9 [json_name = "timestamp_ms"]; */
        if (message.timestamp_ms !== 0n)
            writer.tag(9, WireType.Varint).int64(message.timestamp_ms);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductDetectionExplanation
 */
export const ProductDetectionExplanation = new ProductDetectionExplanation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductDetectionExplanationSearchRequest$Type extends MessageType<ProductDetectionExplanationSearchRequest> {
    constructor() {
        super("brandguard.product.ProductDetectionExplanationSearchRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "event_ids", kind: "scalar", localName: "event_ids", jsonName: "event_ids", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<ProductDetectionExplanationSearchRequest>): ProductDetectionExplanationSearchRequest {
        const message = { offset: 0n, event_ids: [], brand_id: "", limit: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductDetectionExplanationSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductDetectionExplanationSearchRequest): ProductDetectionExplanationSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* repeated string event_ids = 2 [json_name = "event_ids"];*/ 2:
                    message.event_ids.push(reader.string());
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* uint64 limit */ 4:
                    message.limit = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductDetectionExplanationSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* repeated string event_ids = 2 [json_name = "event_ids"]; */
        for (let i = 0; i < message.event_ids.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.event_ids[i]);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* uint64 limit = 4; */
        if (message.limit !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductDetectionExplanationSearchRequest
 */
export const ProductDetectionExplanationSearchRequest = new ProductDetectionExplanationSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductDetectionExplanationSearchResponse$Type extends MessageType<ProductDetectionExplanationSearchResponse> {
    constructor() {
        super("brandguard.product.ProductDetectionExplanationSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ProductDetectionExplanation },
            { no: 2, name: "next", kind: "message", T: () => ProductDetectionExplanationSearchRequest }
        ]);
    }
    create(value?: PartialMessage<ProductDetectionExplanationSearchResponse>): ProductDetectionExplanationSearchResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductDetectionExplanationSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductDetectionExplanationSearchResponse): ProductDetectionExplanationSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.product.ProductDetectionExplanation items */ 1:
                    message.items.push(ProductDetectionExplanation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* brandguard.product.ProductDetectionExplanationSearchRequest next */ 2:
                    message.next = ProductDetectionExplanationSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.next);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductDetectionExplanationSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.product.ProductDetectionExplanation items = 1; */
        for (let i = 0; i < message.items.length; i++)
            ProductDetectionExplanation.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.product.ProductDetectionExplanationSearchRequest next = 2; */
        if (message.next)
            ProductDetectionExplanationSearchRequest.internalBinaryWrite(message.next, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.product.ProductDetectionExplanationSearchResponse
 */
export const ProductDetectionExplanationSearchResponse = new ProductDetectionExplanationSearchResponse$Type();
